export default "__VITE_ASSET__7abb3658__"